import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/bracan',
    name: 'bracan',
    component: () => import('../views/YoyakuBracan.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('setPageTitle', '徳澤園 ブラキャン予約')
      store.dispatch('setPageTitleEng', 'Tokusawaen Bura-Camp Reservation')
      let today = new Date()
      const year = today.getFullYear()
      // 7月1日をカレンダーの開始日にする
      today = new Date(year, 6, 1)
      store.commit('today', today)
      store.commit('Calendar/year', today.getFullYear())
      store.commit('Calendar/month', today.getMonth() + 1)
      store.dispatch('Calendar/get')
      store.dispatch('getBracanSettings')
      next()
    }
  },
  {
    path: '/rentaltent',
    name: 'rentaltent',
    component: () => import('../views/YoyakuRentalTent.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('setPageTitle', '徳澤園 レンタルテント予約')
      store.dispatch('setPageTitleEng', 'Tokusawaen Rental Tent Reservation')
      let today = new Date()
      const year = today.getFullYear()
      // 7月1日をカレンダーの開始日にする
      today = new Date(year, 6, 1)
      store.commit('today', today)
      store.commit('Calendar/year', today.getFullYear())
      store.commit('Calendar/month', today.getMonth() + 1)
      store.dispatch('Calendar/get')
      store.dispatch('getRentaltentSettings')
      next()
    }
  },
  {
    path: '/thanks',
    name: 'thanks',
    component: () => import('../views/ThanksView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
